import { useLocation } from "react-router-dom";
import PrivacyPolicesThai from "./PrivacyPolicesThai";
import PrivacyPolicesEng from "./PrivacyPolicesEng";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const PrivacyPolices = () => {
  let query = useQuery();

  let _returnBody = null;
  try {
    let languages = query.get("languages");
    switch (languages) {
      case "th":
        _returnBody = PrivacyPolicesThai;
        break;
      default:
        // default when languages not found
        _returnBody = PrivacyPolicesEng;
        break;
    }
  } catch (error) {
    // console.error("error")
    //use when got error and return default page
    _returnBody = PrivacyPolicesEng;
  }
  return _returnBody();
};

export default PrivacyPolices;
